'use strict';

var React = require('react');

var SvgTextFontListIcon = function SvgTextFontListIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m5.564 13.968.88-2.5h4.379l.148.403c.132.358.474.597.857.597.634 0 1.075-.632.856-1.228l-3.001-8.15c-.159-.431-.557-.673-.954-.613-.306-.054-.615.134-.733.468l-3.882 11.023h-.439c-.373 0-.675.336-.675.75s.302.75.675.75h2.25c.373 0 .675-.336.675-.75s-.302-.75-.675-.75h-.361Zm3.021-8.578-1.612 4.578h3.298l-1.686-4.578Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.543 17.25c0-.414.335-.75.75-.75h5.5c.414 0 .75.336.75.75s-.336.75-.75.75h-5.5c-.415 0-.75-.336-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.543 14.25c0-.414.335-.75.75-.75h5.5c.414 0 .75.336.75.75s-.336.75-.75.75h-5.5c-.415 0-.75-.336-.75-.75Z"
  }));
};
SvgTextFontListIcon.displayName = "TextFontListIcon";

exports.SvgTextFontListIcon = SvgTextFontListIcon;
